/**
 * Cliente HTTP para todos los endpoints de Contratos.
 * Todas las funciones devuelven la promesa de axios o lanzan el error original.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchContracts = () =>
  axios.get(`${API}/contracts`);

export const createContract = (contractData) =>
  axios.post(`${API}/contracts`, contractData);

export const updateContract = (contractId, contractData) =>
  axios.put(`${API}/contracts/${contractId}`, contractData);

export const deleteContract = (contractId) =>
  axios.delete(`${API}/contracts/${contractId}`);

export const setContractFolio = (contractId, folio) =>
  axios.put(`${API}/contracts/${contractId}/folio`, null, { params: { folio } });

export const updateContractLinks = (contractId, { link_fotos, link_videos }) =>
  axios.put(`${API}/contracts/${contractId}/links`, null, {
    params: { link_fotos, link_videos },
  });

export const updateContractStatus = (contractId, status) =>
  axios.put(`${API}/contracts/${contractId}/status`, null, { params: { status } });

export const toggleContractCancelled = (contractId) =>
  axios.put(`${API}/contracts/${contractId}/toggle-cancelled`);

export const cleanupAndAssignFolios = () =>
  axios.post(`${API}/contracts/cleanup-and-assign-folios`);

export const getNextContractFolio = () =>
  axios.get(`${API}/folios/next/contract_folio`);

export const addAbono = (contractId, abonoData) =>
  axios.post(`${API}/contracts/${contractId}/abonos`, abonoData);

export const updateAbono = (contractId, abonoId, abonoData) =>
  axios.put(`${API}/contracts/${contractId}/abonos/${abonoId}`, abonoData);

export const deleteAbono = (contractId, abonoId) =>
  axios.delete(`${API}/contracts/${contractId}/abonos/${abonoId}`);
